import React, { Component } from 'react';
import Header from "../layout/header"
import Footer from "../layout/footer"
import checkmarkImg from "../images/checkmark.b8187469.svg"
import $ from 'jquery';
import moment from 'moment';
import { secUser, guidance, database } from '../firebase'
export default class AssesmentApply extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fullName: "",
      emailId: "",
      phoneno: "",
      password: "",
      country: "",
      countryData: []
    }
    this.submituserData = this.submituserData.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  async componentDidMount() {
    let countryList = []
    await database.ref("country").once('value', function (snapshot) {
      snapshot.forEach(function (ChildSnapshot) {
        if (ChildSnapshot.val().status == 'Active') {
          countryList.push({
            key: ChildSnapshot.key,
            country: ChildSnapshot.val().country
          });
        }
      });
    });
    this.setState({
      countryData: countryList
    })
  }
  handleChange = (event) => {
    const { value, name } = event.target;
    this.setState({
      [name]: value,
    });
  };
  async submituserData() {

    let newDate = moment(new Date()).format("DD/MM/YYYY")
    const userData = {
      fullName: this.state.fullName,
      emailId: this.state.emailId,
      createdAt: newDate,
      phoneno: this.state.phoneno,
      password: this.state.password,
      country: this.state.country,
      role: "User"

    }
    const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (this.state.fullName === '') {
      alert('Name Required')
    }
    else if (this.state.emailId === '') {
      alert('Email Id Required')
    }
    else if (this.state.emailId !== '' && regex.test(this.state.emailId) === false) {
      alert('Email Id is not valid')
    }
    else if (this.state.phoneno === '') {
      alert('Phone Required')
    }
    else if (this.state.password === '') {
      alert('Password Required')
    }
    else if (this.state.country === '') {
      alert('Located In Required')
    }
    else {
      localStorage.setItem("userName", this.state.fullName);
        const userDataNew = {
          fullName: this.state.fullName,
          emailId: this.state.emailId,
          phoneno: this.state.phoneno,
          password: this.state.password,
          country: this.state.country,
          role: "User"
        }
      const valueRef = secUser.orderByChild('emailId').equalTo(this.state.emailId)
      valueRef.once('value', function(snapshot) {
        console.log("snapshot...",snapshot)
        if(!snapshot.exists()){
      var userKey = secUser.push(userData).key
        
      if (userKey != null) {
        localStorage.setItem("userId", userKey);
        userDataNew.userId = userKey
        // localStorage.setItem("userName", this.state.fullName);
        // const userDataNew = {
        //   userId: userKey,
        //   fullName: this.state.fullName,
        //   emailId: this.state.emailId,
        //   phoneno: this.state.phoneno,
        //   password: this.state.password,
        //   country: this.state.country,
        //   role: "User"
        // }

        const dataSet = {
          userDate: userDataNew,
          createdAt: newDate,
          resumeFile: "",
          resumeLink: "",
          Expertise: "",
          Experience: "",
          Education: "",
          SkillRating: "",
          userId: userKey,
          step2: "false",
          step3: "false",
          step4: "false",
          step5: "false",
          progressInfo: 20,
        }
        var guidanceKey = guidance.push(dataSet).key
        const userDataKey = {
          userId: userKey,
          guidanceId: guidanceKey
        }

        database.ref(`SecUser/${userKey}`).update(userDataKey).then(() => {
          localStorage.setItem("guidanceId", guidanceKey);
          window.location.href = "/assesment/personna/id=" + guidanceKey

        })
      }
    }
    else{
      alert('Email Id already exists!')
    }
    });
    }
  }
  render() {

    return (

      <div className="main-wrapper">
        <Header></Header>
        <div className="main-content assessment-wrapper">
          <div className="container pt-5">
            <div className='row'>
              <div className='col-lg-6'>
                <div className='assessment-left'>
                  {/* <div className='form-head text-left w-100'>Get Started</div> */}
                  <div className="iavno-works-head text-center my-4">
                    <h4>Get Started for Ivanooo today</h4>
                  </div>
                  <p>At Ivanooo, you gain access to recommendations that are not only unbiased but also backed by substantial research. We also take your unique skills into consideration, which makes our recommendations further personalized.</p>

                </div>
              </div>
              <div className='col-lg-6 m-auto px-md-5'>
                <div className='form-main-wrapper'>
                  <div className="form-group">
                    <label for="exampleFormControlInput1">Name <span style={{ color: "#535fe5" }}>*</span></label>
                    <input type="text" name="fullName" id="fullName" className="form-control" onChange={this.handleChange} />
                  </div>
                  <div className="form-group">
                    <label for="exampleFormControlInput1">Email <span style={{ color: "#535fe5" }}>*</span></label>
                    <input type="email" name="emailId" id="emailId" className="form-control" onChange={this.handleChange} />
                  </div>
                  <div className="form-group">
                    <label for="exampleFormControlInput1"> Phone <span style={{ color: "#535fe5" }}>*</span></label>
                    <input type="text" name="phoneno" id="phoneno" className="form-control" onChange={this.handleChange} />
                  </div>
                  <div className="form-group">
                    <label for="exampleFormControlInput1"> Password <span style={{ color: "#535fe5" }}>*</span></label>
                    <input type="password" name="password" id="password" className="form-control" onChange={this.handleChange} />
                  </div>
                  <div className="form-group">
                    <label for="exampleFormControlInput1">Located in<span style={{ color: "#535fe5" }}>*</span></label>
                    <select className="form-control" id="country" name="country" onChange={this.handleChange} >
                      <option value="0">Country</option>
                      {
                        this.state.countryData.map((x, y) =>
                          <option key={x.key} value={x.key}>{x.country}</option>)
                      }
                    </select>
                  </div>
                  {/* <div className="form-group">
                    <label for="exampleFormControlInput1">Are you located in the UAE?
                      <span style={{ color: "#535fe5" }}>*</span></label>
                    <div className='row'>
                      <label for="authorized_usa" className="label-radio" style={{ width: "100px" }}>
                        <input name="authorized_usa" id="authorized_usa" type="radio" value="Yes"  onChange={this.handleChange} />
                        <img className="label-radio-img" alt="Yes" src={checkmarkImg} />
                        <span>Yes</span>
                        <div className="label-radio-checkedBackground"></div>
                      </label>
                      <label for="authorized_usa" className="label-radio" style={{ width: "100px" }}>
                        <input name="authorized_usa" id="authorized_usa" type="radio" value="No"  onChange={this.handleChange} />
                        <img className="label-radio-img" alt="Yes" src={checkmarkImg} />
                        <span>No</span>
                        <div className="label-radio-checkedBackground"></div>
                      </label>
                    </div>
                  </div> */}
                  <div className="form-group mt-4">
                    <a href="#" className="btn btn-theme w-100" onClick={() => this.submituserData()}>
                      Submit
                    </a>

                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ivano/assesment-apply.jsx